<template>
  <f7-page name="customer-edit" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ !CustomerCode ? $t('NewCustomer') : $t('EditCustomer') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="inputSubmitId" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>
    <f7-progressbar v-if="isLoading || isLoadingGetData" infinite color="green" class="progressbar-top"></f7-progressbar>

    <f7-list v-if="isLoadingGetData" media-list class="skeleton-text skeleton-effect-wave" key="assetEditSkeleton">
      <f7-list-item
          v-for="n in 4"
          :key="n"
          title="Title"
          subtitle="Subtitle"
      >
        <template #media>
          <f7-skeleton-block
              style="width: 40px; height: 40px; border-radius: 50%"
          ></f7-skeleton-block>
        </template>
      </f7-list-item>
    </f7-list>

    <form v-else @submit.prevent="onSubmit">
      <input type="submit" :id="inputSubmitId" hidden >

      <f7-block-title class="display-flex justify-content-space-between white-space-normal">
        <span>{{ $t('CustomerInfo') }}</span>
        <span class="font-style-italic margin-left-half ">
          <f7-checkbox name="SendRegLetter" v-model:checked="isSendRegLetter" color="green" class="display-flex align-items-center"><span class="margin-left-half ">{{ $t('SendRegLetter') }}</span></f7-checkbox>
        </span>
      </f7-block-title>
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            name="AccountName"
            required
            validate
            validate-on-blur
            :label="$t('AccountName')"
            :placeholder="$t('AccountName')"
            v-model:value.trim="AccountName"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Type')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyCustomerTypeList'+keyCustomerTypeList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="CustomerTypeList" v-model="CustomerTypeCode">
            <option
                v-for="type in CustomerTypeList"
                :key="type.code"
                :value="type.code"
            >{{type.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Language')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, scrollToSelectedItem: true, formColorTheme: 'green' }"
            :key="'keyLanguageList'+keyLanguageList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-other-language text-color-lightgray"></f7-icon>
          </template>
          <select name="LanguageList" v-model="LanguageCode">
            <option
                v-for="language in LanguageList"
                :key="language.code"
                :value="language.code"
            >{{language.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Country')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, scrollToSelectedItem: true, formColorTheme: 'green' }"
            :key="'keyCountryList'+keyCountryList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="CountryList" v-model="CountryCode">
            <option
                v-for="country in CountryList"
                :key="country.CountryCode"
                :value="country.CountryCode"
            >{{country.Country}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('TimeFormat')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyTimeFormatList'+keyTimeFormatList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-year text-color-lightgray"></f7-icon>
          </template>
          <select name="CountryList" v-model="TimeFormatCode">
            <option
                v-for="timeFormat in TimeFormatList"
                :key="timeFormat.code"
                :value="timeFormat.code"
            >{{timeFormat.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('TimeZone')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, scrollToSelectedItem: true, formColorTheme: 'green' }"
            :key="'keyTimeZoneList'+keyTimeZoneList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-time text-color-lightgray"></f7-icon>
          </template>
          <select name="TimeZone" v-model="TimeZoneCode">
            <option
                v-for="timeZone in TimeZoneList"
                :key="timeZone.code"
                :value="timeZone.code"
            >{{timeZone.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Theme')"
            smart-select
            :smart-select-params="{openIn: 'popup', closeOnSelect: true, scrollToSelectedItem: true, formColorTheme: 'green' }"
            :key="'keyThemeList'+keyThemeList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="CountryList" v-model="ThemeCode">
            <option
                v-for="theme in ThemeList"
                :key="theme.Code"
                :value="theme.Code"
            >{{theme.Name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('WebSite')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, scrollToSelectedItem: true, formColorTheme: 'green' }"
            :key="'keyWebsiteList'+keyWebsiteList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="Domain" v-model="WebsiteCode">
            <option
                v-for="website in WebsiteList"
                :key="website.Code"
                :value="website.Code"
                :data-display-as="website.Name"
            >{{website.Name}}({{website.URL}})</option>
          </select>
        </f7-list-item>
        <!--<f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Group')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, scrollToSelectedItem: true, formColorTheme: 'green' }"
            :key="'keyGroupList'+keyGroupList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="GroupList" v-model="GroupCode">
            <option
                v-for="group in GroupList"
                :key="group.Code"
                :value="group.Code"
            >{{group.Name}}</option>
          </select>
        </f7-list-item>-->

        <f7-list-input
            type="text"
            name="SecurityCode"
            :label="$t('SecurityCode')"
            :placeholder="$t('SecurityCode')"
            v-model:value.trim="SecurityCode"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('SpeedUnit')"
            smart-select
            :smart-select-params="{openIn: 'popover', closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keySpeedUnitList'+keySpeedUnitList"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-odometer text-color-lightgray"></f7-icon>
          </template>
          <select name="SpeedUnitList" v-model="SpeedUnitCode">
            <option
                v-for="speedUnit in SpeedUnitList"
                :key="speedUnit.code"
                :value="speedUnit.code"
            >{{speedUnit.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-input
            type="text"
            name="Credits"
            :label="$t('Credits')"
            :placeholder="$t('Credits')"
            v-model:value="Credits"
            :class="{disabled : !IS_ROOT}"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-menu-credits text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-item
            v-if="!isAgentOrDealer"
            checkbox
            :title="$t('SendMonthlyAccountReport')"
            name="checkbox-monthly-account-report"
            v-model:checked="isSendMonthlyAccountReport"
            color="green">
        </f7-list-item>
      </f7-list>

      <f7-block-title>{{ $t('ContactInfo') }}</f7-block-title>
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            name="FirstName"
            required
            validate
            validate-on-blur
            :label="$t('FirstName')"
            :placeholder="$t('FirstName')"
            v-model:value.trim="FirstName"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="LastName"
            required
            validate
            validate-on-blur
            :label="$t('LastName')"
            :placeholder="$t('LastName')"
            v-model:value.trim="LastName"
        >
          <template #media>
            <f7-icon icon="f7-icons icon- text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="LoginName"
            required
            validate
            validate-on-blur
            :label="$t('LoginName')"
            :placeholder="$t('LoginName')"
            v-model:value.trim="LoginName"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-password text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="email"
            required
            validate
            validate-on-blur
            name="email"
            :label="$t('Email')"
            :placeholder="$t('Email')"
            v-model:value.trim="Email"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-email text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="tel"
            name="Mobile"
            :label="$t('Mobile')"
            :placeholder="$t('Mobile')"
            v-model:value.trim="Mobile"
            :error-message="$t('OnlyNumbers')"
            pattern="[0-9]*"
        >
          <template #media>
            {{ phoneCode }}
            <!--<f7-icon icon="f7-icons icon-mobile text-color-lightgray"></f7-icon>-->
          </template>
        </f7-list-input>
        <f7-list-input
            type="tel"
            name="Phone"
            :label="$t('Phone')"
            :placeholder="$t('Phone')"
            v-model:value.trim="Phone"
            :error-message="$t('OnlyNumbers')"
            pattern="[0-9]*"
        >
          <template #media>
            <!--<f7-icon icon="f7-icons icon-mobile text-color-lightgray"></f7-icon>-->
            {{ phoneCode }}
          </template>
        </f7-list-input>
      </f7-list>

      <f7-block-title v-if="isAgentOrDealer"
                      class="display-flex justify-content-space-between white-space-normal">
        <span>{{ $t('SolutionPermission') }}</span>
        <span class="font-style-italic margin-left-half">
          <f7-checkbox name="SyncSubAgent" v-model:checked="isSolutionSyncSubAgent" color="green" class="display-flex align-items-center" ><span class="margin-left-half ">{{ $t('SyncSubAgent') }}</span></f7-checkbox>
        </span>
      </f7-block-title>

      <div v-if="isAgentOrDealer"
           class="list no-margin-top no-hairline-bottom">
        <ul class="row no-gap">
          <f7-list-item
              v-for="solution of SolutionTypeList" :key="solution.Code"
              checkbox
              :title="solution.Name"
              name="checkbox-solution-permission"
              v-model:checked="Permissions[solution.Value]"
              :value="solution.Value"
              class="col-50"
              color="green">
          </f7-list-item>
        </ul>
      </div>

      <f7-block-title>{{ $t('UserPermission') }}</f7-block-title>
      <div class="list no-margin-top no-hairline-bottom">
        <ul class="row no-gap">
          <f7-list-item
              v-for="userPermission of UserPermissionList" :key="userPermission.code"
              checkbox
              :title="userPermission.name"
              name="checkbox-user-permission"
              v-model:checked="UserPermissions[userPermission.code]"
              :value="userPermission.code"
              class="col-50"
              color="green">
          </f7-list-item>
        </ul>
      </div>

      <f7-block-title v-if="isAgentOrDealer">{{ $t('AdminPermission') }}</f7-block-title>
      <div v-if="isAgentOrDealer"
           class="list no-margin-top no-hairline-bottom">
        <ul class="row no-gap">
          <f7-list-item
              v-for="adminPermission of AdminPermissionList" :key="adminPermission.code"
              checkbox
              :title="adminPermission.name"
              name="checkbox-admin-permission"
              v-model:checked="Permissions[adminPermission.code]"
              :value="adminPermission.code"
              class="col-50"
              color="green">
          </f7-list-item>
        </ul>
      </div>

      <f7-block-title v-if="IS_ROOT && isAgentOrDealer">{{ $t('InstallerPermission') }}</f7-block-title>
      <div v-if="IS_ROOT && isAgentOrDealer"
           class="list no-margin-top no-hairline-bottom">
        <ul class="row no-gap">
          <f7-list-item
              v-for="permission of InstallerPermissions" :key="`key-installer-permission-${ permission.code }`"
              checkbox
              :title="permission.name"
              name="checkbox-installer-permission"
              v-model:checked="InstallerPermissionIds[permission.code]"
              :value="permission.code"
              class="col-50"
              color="green">
          </f7-list-item>
        </ul>
      </div>

      <f7-block-title v-if="isAgentOrDealer">{{ $t('AlarmMonitor') }}</f7-block-title>
      <div v-if="isAgentOrDealer"
           class="list no-margin-top no-hairline-bottom">
        <ul class="row no-gap">
          <!--v-model:checked="SOSButton"-->

          <f7-list-item
              v-for="alarmMonitor of AlarmMonitorList" :key="alarmMonitor.code"
              checkbox
              :title="alarmMonitor.name"
              name="checkbox-alarm-monitor"
              v-model:checked="AlarmMonitorIds[alarmMonitor.code]"
              :value="alarmMonitor.code"
              class="col-50"
              color="green">
          </f7-list-item>
        </ul>
      </div>

      <email-list
          v-if="isAgentOrDealer"
          :title="$t('AlarmEmailList')"
          v-model:emails="AlarmEmails"
      />

      <f7-block-title>{{ $t('AddressDetails') }}</f7-block-title>
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            name="Address"
            :label="$t('Address')"
            :placeholder="$t('Address')"
            v-model:value.trim="Address"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-position text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Address1"
            :label="$t('Address')+2"
            :placeholder="$t('Address')+2"
            v-model:value.trim="Address1"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-position text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="city"
            :label="$t('City')"
            :placeholder="$t('City')"
            v-model:value.trim="City"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="state"
            :label="$t('StateProvince')"
            :placeholder="$t('StateProvince')"
            v-model:value.trim="State"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="zipcode"
            :label="$t('ZipCode')"
            :placeholder="$t('ZipCode')"
            v-model:value.trim="Zipcode"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
      </f7-list>
    </form>



  </f7-page>
</template>

<script>
import {f7} from "framework7-vue";
import {
  CustomerTypes,
  getCountries,
  getTimeZones,
  getTimeFormats,
  getLanguages,
  getSpeedUnitList,
  getCustomerTypes,
  getUserPermissions,
  getAdminPermissions,
  getAlarmMonitorList,
  getInstallerPermissionList,
  InstallerPermissionEnum,
  SortArrayByObjProps,
  AdminPermissionsEnum,
  Permissions2Enum,
} from "../../js/helpers";
import {QTAPI} from "../../services/qt-api";
import {mapGetters} from "vuex";
import EmailList from "../../components/email-list"


export default {
  name: "customer-edit",

  props: {
    f7router: Object,
    f7route: Object,
  },

  components: {
    EmailList
  },

  data(){
    let UserInfoPreEdit = this.$store.getters.UserInfoPreEdit

    return {
      inputSubmitId: f7.utils.id(),
      isLoading: false,
      isLoadingGetData: false,
      isLoadingSSP: false,

      keyCustomerTypeList: 1,
      keyLanguageList: 1,
      keyCountryList: 1,
      keyTimeFormatList: 1,
      keyTimeZoneList: 1,
      keyThemeList: 1,
      keyWebsiteList: 1,
      keyGroupList: 1,
      keySpeedUnitList: 1,

      CustomerTypesEnum: CustomerTypes,
      CustomerTypeList: getCustomerTypes(),
      LanguageList: getLanguages(),
      CountryList: getCountries(),
      TimeFormatList: getTimeFormats(),
      TimeZoneList: getTimeZones(),
      ThemeList: [{Code: '0', Name: this.$t('Default')}],
      WebsiteList: [],
      GroupList: [],
      SpeedUnitList: getSpeedUnitList(),
      SolutionTypeList: [],
      UserPermissionList: SortArrayByObjProps(getUserPermissions(), [{prop: 'name', direction: 1}]),
      AdminPermissionList: [],
      InstallerPermissions: SortArrayByObjProps(getInstallerPermissionList(), [{prop: 'name', direction: 1}]),
      AlarmMonitorList: SortArrayByObjProps(getAlarmMonitorList(), [{prop: 'name', direction: 1}]),
      Permissions: {},
      AlarmMonitorIds: {},
      UserPermissions: {},
      InstallerPermissionIds: {},

      AccountName: null,
      CustomerTypeCode: 5,
      LanguageCode: UserInfoPreEdit?.ContactInfo?.Language || "en",
      CountryCode: UserInfoPreEdit?.ContactInfo?.CountryCode || "AUS",
      TimeFormatCode: UserInfoPreEdit?.ContactInfo?.TimeFormat || "dd/MM/yyyy HH:mm:ss",
      TimeZoneCode: "W. Australia Standard Time_8",
      ThemeCode: UserInfoPreEdit?.CustomerInfo?.ExtDoaminCode || "0",
      WebsiteCode: UserInfoPreEdit?.CustomerInfo?.WebSiteCode || "00000000-0000-0000-0000-000000000000",
      FirstName: null,
      LastName: null,
      LoginName: null,
      Email: null,
      Mobile: null,
      Phone: null,
      GroupCode: null,
      SpeedUnitCode: UserInfoPreEdit?.CustomerInfo?.SpeedUnit || 'KPH',
      Address: null,
      Address1: null,
      City: null,
      State: null,
      Zipcode: null,
      AlarmEmails: null,
      //ActivationEmails: null,
      Credits: null,
      PaymentType: 'NONE',
      Number: null,
      UserCode: null,
      SecurityCode: null,
      CustomerCode: this.f7route.query.customerCode,
      isSolutionSyncSubAgent: false,
      isSendRegLetter: false,
      isSendMonthlyAccountReport: true,
    }
  },

  computed: {
    ...mapGetters(['IS_ROOT', 'MajorToken', 'MinorToken', 'UserInfoPreEdit']),
    phoneCode(){
      let country = this.CountryList.length ? this.CountryList.find((itm)=> itm.CountryCode === this.CountryCode) : ''
      return country ? country.CountryPhoneCode : '';
    },
    isAgentOrDealer(){
      return +this.CustomerTypeCode === +this.CustomerTypesEnum?.Agent || +this.CustomerTypeCode === +this.CustomerTypesEnum?.Dealer
    }
  },

  mounted() {
    this.AdminPermissionList = SortArrayByObjProps(getAdminPermissions(this.IS_ROOT), [{prop: 'name', direction: 1}])

    this.getPreEditCustomerInfo();
  },

  methods: {


    async getPreEditCustomerInfo(){
      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,
      }
      if(this.CustomerCode){
        data.Code = this.CustomerCode
      }
      this.isLoadingGetData = true;
      let result = await QTAPI.GetPreEditCustomerInfo(data)
      this.isLoadingGetData = false;
      if(!result){
        return
      }
      //console.log(result)
      if(result.ExternalDomains && result.ExternalDomains.length){
        this.ThemeList = [...this.ThemeList, ...result.ExternalDomains]
      }
      if(result.WebSites && result.WebSites.length){
        this.WebsiteList = result.WebSites
      }
      if(result.Solutions && result.Solutions.length){
        this.SolutionTypeList = result.Solutions
      }
      if(result.AlarmEmails){
        this.AlarmEmails = result.AlarmEmails
      }
      if(result.MonitorAlarmIDs){
        this.setAlarmMonitor(result.MonitorAlarmIDs)
      }
      if(this.CustomerCode && result.Permissions){
        this.setSolutionAndAdminPermissions(result.Permissions)
      }

      if(this.CustomerCode && result.CustomerInfo){
        this.setCustomerInfo(result.CustomerInfo)
      }
      if(this.CustomerCode && result.ContactInfo){
        this.setContactInfo(result.ContactInfo)
      }
      if(this.CustomerCode && result.CustomerInfo?.TimeZoneID || this.CustomerCode && result.ContactInfo?.TimeZone){
        this.TimeZoneCode = !result?.CustomerInfo?.TimeZoneID ? this.TimeZoneList.find(itm => parseFloat(itm.code) === parseFloat(result.ContactInfo?.TimeZone))?.code : this.TimeZoneList.find(itm => itm.id === result.CustomerInfo?.TimeZoneID)?.code
      }
      if(this.IS_ROOT && this.CustomerCode && result.ContactInfo && result.ContactInfo.Permissions){
        this.setInstallerPermissions(result.ContactInfo.Permissions)
      }

      this.UserPermissions.Controllable = !!result.Controllable
      this.UserPermissions.AllowCommand = !!result.AllowCommand

      if(result?.BillInfo?.PaymentType){
        this.PaymentType = result.BillInfo.PaymentType
      }

      this.isSendMonthlyAccountReport = (result?.Permissions2 & Permissions2Enum.MonthlyAccountReport) === 0

    },
    setContactInfo(contactInfo){
      this.UserCode = contactInfo.Code
      this.LanguageCode = contactInfo.Language
      this.CountryCode =  contactInfo.CountryCode
      this.TimeFormatCode = contactInfo.TimeFormat
      //this.TimeZoneCode = this.TimeZoneList.find(itm => parseFloat(itm.code) === parseFloat(contactInfo.TimeZone)).code
      this.FirstName = contactInfo.FirstName
      this.LastName = contactInfo.SurName
      this.LoginName = contactInfo.LoginName
      this.Email = contactInfo.Mail
      this.Mobile = contactInfo.MobilePhone
      this.Phone = contactInfo.WorkPhone
      this.GroupCode = contactInfo.CustomerContactGroupCode
      this.Credits = contactInfo._FIELD_INT1


      //console.log(this.InstallerPermissionIds)

      this.keyTimeZoneList++
      this.keyCountryList++
      this.keyLanguageList++
      this.keyTimeFormatList++
      this.keyGroupList++
    },
    setCustomerInfo(customerInfo){

      //console.log(customerInfo)
      this.AccountName = customerInfo.Name
      this.Number = customerInfo.Number
      this.CustomerTypeCode = customerInfo.Type
      this.ThemeCode = !customerInfo.ExtDoaminCode ? "0" : customerInfo.ExtDoaminCode
      this.WebsiteCode = customerInfo.WebSiteCode
      this.SpeedUnitCode = !customerInfo.SpeedUnit ? 'KPH' : customerInfo.SpeedUnit
      this.SecurityCode = customerInfo.SecurityCode

      let addressArr = !customerInfo.Address ? [] : customerInfo.Address.split('\n')
      if(addressArr.length){
        this.Address = addressArr[1]
        this.Address1 = addressArr[2]
        this.City = addressArr[3]
        this.State = addressArr[4]
        this.Zipcode = addressArr[5]
      }

      this.keyCustomerTypeList++
      this.keyWebsiteList++
      this.keySpeedUnitList++

    },
    setSolutionAndAdminPermissions(permissionsStr){
      if(!permissionsStr.trim()){
        return
      }
      this.SolutionTypeList.map((itm) => {
        if(permissionsStr.indexOf(itm.Value+',') > -1){
          this.Permissions[itm.Value] = true
        }
      })
      this.AdminPermissionList.map((itm) => {
        if(permissionsStr.indexOf(itm.code+',') > -1){
          this.Permissions[itm.code] = true
        }
      })
    },
    setAlarmMonitor(alarmsIdsStr){
      if(!alarmsIdsStr.trim()){
        return
      }
      let alarmIds = alarmsIdsStr.split(',')
      alarmIds.forEach((itm) => {
        if(!itm){ return }
        this.AlarmMonitorIds[itm] = true
      })
    },
    setInstallerPermissions(permissions){
      permissions = +permissions
      if(!permissions) return

      Object.values(InstallerPermissionEnum).forEach(itm => {
        this.InstallerPermissionIds[itm] = (permissions & itm) > 0
      })
    },

    async onSubmit(){
      let uniqNum = f7.utils.id('xxxxxx')
      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        Name: this.AccountName,
        Type: this.CustomerTypeCode,
        SecurityCode: this.SecurityCode || uniqNum,
        Number: this.Number || uniqNum,
        CountryCode: this.CountryCode,
        TimeFormat: this.TimeFormatCode,
        TimeZone: this.TimeZoneCode,
        Language: this.LanguageCode,
        ExtDoaminCode: this.ThemeCode !== "0" ? this.ThemeCode : '',
        WebSiteCode: this.WebsiteCode,
        SpeedUnit: this.SpeedUnitCode,

        FirstName: this.FirstName,
        SurName: this.LastName,
        LoginName: this.LoginName,
        Mail: this.Email,
        MobilePhone: this.Mobile,
        WorkPhone: this.Phone,

        AddressInfo1: this.Address,
        AddressInfo2: this.Address1,
        AddressInfo3: this.City,
        AddressInfo4: this.State,
        AddressInfo5: this.Zipcode,

        PayType: this.PaymentType,

        Controllable: !!this.UserPermissions.Controllable ? 1 : 0,
        AllowCommand: !!this.UserPermissions.AllowCommand ? 1 : 0,
      }

      if(this.CustomerCode){
        data.Code = this.CustomerCode
      }

      if(!this.isAgentOrDealer){
        data.autoMonthlyReport = !this.isSendMonthlyAccountReport ? Permissions2Enum.MonthlyAccountReport : 0
      }

      if(this.isAgentOrDealer){
        data.ActivationDevices = []
        Object.entries(this.Permissions).forEach(([key, val]) => { if(val) data.ActivationDevices.push(key) })
        data.ActivationDevices = data.ActivationDevices.toString()

        data.Alerts = []
        Object.entries(this.AlarmMonitorIds).forEach(([key, val]) => { if(val) data.Alerts.push(key) })
        data.Alerts = data.Alerts.toString()

        data.AEmails = this.AlarmEmails?.length ? this.AlarmEmails.toString() : ''

        if(this.isSolutionSyncSubAgent){
          data.ActivationDevices_SynchronizsubAgent = 'SynchronizsubAgent'
        }
      }
      if(this.IS_ROOT){
        data.Credits = this.Credits
        if(this.isAgentOrDealer){
          data.Permission = []
          Object.entries(this.InstallerPermissionIds).forEach(([key, val]) => { if(val) data.Permission.push(key) })
          data.Permission = data.Permission.toString()

          Object.entries(AdminPermissionsEnum).forEach(([key, val]) => {
            if(this.Permissions[val]){
              data[key] = val
            }
          })
        }
      }

      this.isLoading = true;
      let result = await QTAPI.CustomerEditInfo(data)
      this.isLoading = false;
      if(!result) return

      if(this.isSendRegLetter){
        this.sendRegLetter(this.CustomerCode || result )
      }

      this.$store.commit('CUSTOMER_UPDATED')
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: !this.CustomerCode ? this.$t('CustomerCreated', { name: data.Name }) : this.$t('CustomerUpdated', { name: data.Name }),
      }).open()
      this.f7router.back()

    },
    async sendRegLetter(code){
      let result = await QTAPI.SendRegLetter({
        EMails: [this.Email],
        WebsiteCode: this.WebsiteCode,
        LoginName: this.LoginName,
        CustomerCode: code,
      })
      if(!result) return

      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('LetterSent'),
      }).open()
    }
  }
}
</script>

<style scoped>

</style>